import React, { useState,useEffect } from "react";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import IncidentForm from "./incidentForm";
import Request from "../../utils/http";

const request = new Request();

function ItemStage(props) {
  const [cantidadBodega, setCantidadBodega] = useState(1);
  const [cantidadSubrenta, setCantidadSubrenta] = useState(0);
  const [indicaciones, setIndicaciones] = useState(
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry..."
  );
  const [codigosPreparados, setCodigosPreparados] = useState(["MIC-00001"]);
  const [cantidadSinCodigo, setCantidadSinCodigo] = useState(0);
  const [inputCantidadSinCodigo, setInputCantidadSinCodigo] = useState(0);
  const [mensaje, setMensaje] = useState("");

  /*/ Estado para el modal */
  const [modalIsOpen, setModalIsOpen] = useState(false);

  /*/ Función para abrir el modal */
  const openModal = () => {
    setModalIsOpen(true);
  };

  /*/ Función para cerrar el modal */
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const customStyles = {
    content: {
      position: "absolute",
      top: "15%",
      left: "15%",
      right: "15%",
      bottom: "15%",
      border: "1px solid rgb(204, 204, 204)",
      background: "rgb(255, 255, 255)",
      overflow: "auto",
      outline: "none",
      padding: "10px",
    },
  };
  const fetchListData = async () => {
    let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
    let token;
    if (token1) {
      token = token1.id;
    }
    if (!token) {
      toast.error("No hay token de sesión disponible");
      return;
    }
    try {
      const postData = {
        token: token,
        idEvento: props.info.id_evento,
        idSub: props.sub,
        idArt: props.info.id_art,
        status:(props.stage)
      };

      const response = await request.post(
        "/auth/inventory/buscarEtapasSeguimiento", // Replace this with the actual endpoint
        postData
      );
      console.log(response);
      if(response.status==404)
        setCantidadSinCodigo(0);
      else
      {setCantidadSinCodigo(response.result[0].total_cant_scodigo)}
      //setListData(response.data); // Assuming the response has a "data" field
    } catch (error) {
      console.error("Error fetching list data:", error);
      toast.error("No se pudieron cargar los datos");
    }
  };

  // Fetch the list data on component mount
  useEffect(() => {
    fetchListData();
  }, [props.info.id_evento, props.sub, props.info.id_art]); // Trigger when the event or sub event changes

  const handleGuardar = async () => {
    let token1 = JSON.parse(sessionStorage.getItem("decoAdmin"));
    let token;
    if (token1) {
      token = token1.id;
    }
    if (!token) {
      toast.error("No hay token de sesión disponible");
      return;
    }
    try {
      const postData = {
        token: token,
        idEvento: props.info.id_evento,
        idSub: props.sub,
        idArt: props.info.id_art,
        cantidad:inputCantidadSinCodigo,
        etapa: props.stage,
      };

      const response = await request.post(
        "/auth/inventory/insertarEtapaSeguimiento",
        postData
      );
      console.log(response);
      toast.success("Cantidad guardada correctamente");
      let sum=parseInt(inputCantidadSinCodigo)+parseInt(cantidadSinCodigo);
      setCantidadSinCodigo(sum);
    } catch (error) {
      console.error("Error al cargar datos:", error);
      toast.error("No se pudieron cargar las datos almacenados");
    }
  };
  return (
    <div className="row g-4 border p-4 rounded shadow">
      <div className="col-md-8 row ">
        {/* Información Evento */}
        <div className="col-md-6">
          <div className="bg-primary text-white p-2 rounded-top">
            INFORMACIÓN EVENTO {props.info.id_evento}
          </div>
          <div className="border border-top-0 p-2">
            <div className="mb-2">Nombre: {props.eve.nombre}</div>
            <div className="mb-2">
              Subevento {props.sub}: {props.info.nombre}
            </div>
            <div className="mb-2">
              Fecha de Entrega: {props.info.fecha_entrega}
            </div>
          </div>
        </div>

        {/* Solicitados */}
        <div className="col-md-6">
          <div className="bg-success text-white p-2 rounded-top">
            SOLICITADOS
          </div>
          <div className="border border-top-0 p-2">
            <div className="mb-2">
              ({props.info.id_art}) {props.info.nomE}
            </div>
            <div className="mb-2">
              Cantidad de Bodega{" "}
              <span className="badge badge-success text-md">{props.info.cantidad}</span>
            </div>
            <div className="mb-2">
              Cantidad de Subrenta{" "}
              <span className="badge badge-danger text-md">
                {props.info.produccion}
              </span>
            </div>
          </div>
        </div>

        {/* Indicaciones */}
        {props.info.indicaciones && (
          <div className="col-md-12 border rounded shadow mt-1">
            <div className="bg-primary text-white p-2 rounded-top">
              INDICACIONES:
            </div>
            <textarea
              className="form-control"
              rows="4"
              value={props.info.indicaciones}
              onChange={(e) => setIndicaciones(e.target.value)}
            />
          </div>
        )}

        <div className="col-md-6 mt-4">
          <div className="bg-primary text-white p-2 rounded-top">
            CANTIDAD ENVIADA:
            <span className="badge badge-success text-md">
              {cantidadSinCodigo}
            </span>
          </div>
          <div className="input-group">
            <input
              type="number"
              className="form-control"
              value={inputCantidadSinCodigo}
              onChange={(e) =>
                setInputCantidadSinCodigo(parseInt(e.target.value))
              }
            />
            <div className="input-group-append">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleGuardar}
              >
                <i className="fas fa-save"></i> Guardar
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6 mt-4">
          <div className="bg-primary text-white p-2 rounded-top">
            INCIDENCIAS:{" "}
            <button
              type="button"
              className="btn btn-warning"
              onClick={openModal}
            >
              <i className="fas fa-wrench"></i> Agregar
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Agregar Incidencia"
        style={customStyles}
      >
        <div className="modal-header">
          <h5 className="modal-title">Agregar Incidencia</h5>
          <button type="button" className="close" onClick={closeModal}>
            <span>&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <IncidentForm
            etapa={props.stage}
            idEvento={props.info.id_evento}
            sub={props.sub}
            idArt={props.info.id_art}
          />
        </div>
      </Modal>

      {/* Imagen */}
      <div className="col-md-4 d-flex align-items-center justify-content-center">
        <img
          src={props.img}
          alt={props.info.nomE}
          className="rounded img-fluid"
        />
      </div>
    </div>
  );
}

export default ItemStage;
